export var tbKeyCodes;
(function (tbKeyCodes) {
    tbKeyCodes[tbKeyCodes["vkCancel"] = 3] = "vkCancel";
    tbKeyCodes[tbKeyCodes["vkHelp"] = 6] = "vkHelp";
    tbKeyCodes[tbKeyCodes["vkBackspace"] = 8] = "vkBackspace";
    tbKeyCodes[tbKeyCodes["vkTab"] = 9] = "vkTab";
    tbKeyCodes[tbKeyCodes["vkClear"] = 12] = "vkClear";
    tbKeyCodes[tbKeyCodes["vkReturn"] = 13] = "vkReturn";
    tbKeyCodes[tbKeyCodes["vkEnter"] = 14] = "vkEnter";
    tbKeyCodes[tbKeyCodes["vkShift"] = 16] = "vkShift";
    tbKeyCodes[tbKeyCodes["vkControl"] = 17] = "vkControl";
    tbKeyCodes[tbKeyCodes["vkAlt"] = 18] = "vkAlt";
    tbKeyCodes[tbKeyCodes["vkPause"] = 19] = "vkPause";
    tbKeyCodes[tbKeyCodes["vkCapslock"] = 20] = "vkCapslock";
    tbKeyCodes[tbKeyCodes["vkEscape"] = 27] = "vkEscape";
    tbKeyCodes[tbKeyCodes["vkSpace"] = 32] = "vkSpace";
    tbKeyCodes[tbKeyCodes["vkPageup"] = 33] = "vkPageup";
    tbKeyCodes[tbKeyCodes["vkPagedown"] = 34] = "vkPagedown";
    tbKeyCodes[tbKeyCodes["vkEnd"] = 35] = "vkEnd";
    tbKeyCodes[tbKeyCodes["vkHome"] = 36] = "vkHome";
    tbKeyCodes[tbKeyCodes["vkLeft"] = 37] = "vkLeft";
    tbKeyCodes[tbKeyCodes["vkUp"] = 38] = "vkUp";
    tbKeyCodes[tbKeyCodes["vkRight"] = 39] = "vkRight";
    tbKeyCodes[tbKeyCodes["vkDown"] = 40] = "vkDown";
    tbKeyCodes[tbKeyCodes["vkPrintscreen"] = 44] = "vkPrintscreen";
    tbKeyCodes[tbKeyCodes["vkInsert"] = 45] = "vkInsert";
    tbKeyCodes[tbKeyCodes["vkDelete"] = 46] = "vkDelete";
    tbKeyCodes[tbKeyCodes["vk0"] = 48] = "vk0";
    tbKeyCodes[tbKeyCodes["vk1"] = 49] = "vk1";
    tbKeyCodes[tbKeyCodes["vk2"] = 50] = "vk2";
    tbKeyCodes[tbKeyCodes["vk3"] = 51] = "vk3";
    tbKeyCodes[tbKeyCodes["vk4"] = 52] = "vk4";
    tbKeyCodes[tbKeyCodes["vk5"] = 53] = "vk5";
    tbKeyCodes[tbKeyCodes["vk6"] = 54] = "vk6";
    tbKeyCodes[tbKeyCodes["vk7"] = 55] = "vk7";
    tbKeyCodes[tbKeyCodes["vk8"] = 56] = "vk8";
    tbKeyCodes[tbKeyCodes["vk9"] = 57] = "vk9";
    tbKeyCodes[tbKeyCodes["vkSemicolon"] = 59] = "vkSemicolon";
    tbKeyCodes[tbKeyCodes["vkEquals"] = 61] = "vkEquals";
    tbKeyCodes[tbKeyCodes["vkA"] = 65] = "vkA";
    tbKeyCodes[tbKeyCodes["vkB"] = 66] = "vkB";
    tbKeyCodes[tbKeyCodes["vkC"] = 67] = "vkC";
    tbKeyCodes[tbKeyCodes["vkD"] = 68] = "vkD";
    tbKeyCodes[tbKeyCodes["vkE"] = 69] = "vkE";
    tbKeyCodes[tbKeyCodes["vkF"] = 70] = "vkF";
    tbKeyCodes[tbKeyCodes["vkG"] = 71] = "vkG";
    tbKeyCodes[tbKeyCodes["vkH"] = 72] = "vkH";
    tbKeyCodes[tbKeyCodes["vkI"] = 73] = "vkI";
    tbKeyCodes[tbKeyCodes["vkJ"] = 74] = "vkJ";
    tbKeyCodes[tbKeyCodes["vkK"] = 75] = "vkK";
    tbKeyCodes[tbKeyCodes["vkL"] = 76] = "vkL";
    tbKeyCodes[tbKeyCodes["vkM"] = 77] = "vkM";
    tbKeyCodes[tbKeyCodes["vkN"] = 78] = "vkN";
    tbKeyCodes[tbKeyCodes["vkO"] = 79] = "vkO";
    tbKeyCodes[tbKeyCodes["vkP"] = 80] = "vkP";
    tbKeyCodes[tbKeyCodes["vkQ"] = 81] = "vkQ";
    tbKeyCodes[tbKeyCodes["vkR"] = 82] = "vkR";
    tbKeyCodes[tbKeyCodes["vkS"] = 83] = "vkS";
    tbKeyCodes[tbKeyCodes["vkT"] = 84] = "vkT";
    tbKeyCodes[tbKeyCodes["vkU"] = 85] = "vkU";
    tbKeyCodes[tbKeyCodes["vkV"] = 86] = "vkV";
    tbKeyCodes[tbKeyCodes["vkW"] = 87] = "vkW";
    tbKeyCodes[tbKeyCodes["vkX"] = 88] = "vkX";
    tbKeyCodes[tbKeyCodes["vkY"] = 89] = "vkY";
    tbKeyCodes[tbKeyCodes["vkZ"] = 90] = "vkZ";
    tbKeyCodes[tbKeyCodes["vkContextmenu"] = 93] = "vkContextmenu";
    tbKeyCodes[tbKeyCodes["vkNumpad0"] = 96] = "vkNumpad0";
    tbKeyCodes[tbKeyCodes["vkNumpad1"] = 97] = "vkNumpad1";
    tbKeyCodes[tbKeyCodes["vkNumpad2"] = 98] = "vkNumpad2";
    tbKeyCodes[tbKeyCodes["vkNumpad3"] = 99] = "vkNumpad3";
    tbKeyCodes[tbKeyCodes["vkNumpad4"] = 100] = "vkNumpad4";
    tbKeyCodes[tbKeyCodes["vkNumpad5"] = 101] = "vkNumpad5";
    tbKeyCodes[tbKeyCodes["vkNumpad6"] = 102] = "vkNumpad6";
    tbKeyCodes[tbKeyCodes["vkNumpad7"] = 103] = "vkNumpad7";
    tbKeyCodes[tbKeyCodes["vkNumpad8"] = 104] = "vkNumpad8";
    tbKeyCodes[tbKeyCodes["vkNumpad9"] = 105] = "vkNumpad9";
    tbKeyCodes[tbKeyCodes["vkMultiply"] = 106] = "vkMultiply";
    tbKeyCodes[tbKeyCodes["vkAdd"] = 107] = "vkAdd";
    tbKeyCodes[tbKeyCodes["vkSeparator"] = 108] = "vkSeparator";
    tbKeyCodes[tbKeyCodes["vkSubtract"] = 109] = "vkSubtract";
    tbKeyCodes[tbKeyCodes["vkDecimal"] = 110] = "vkDecimal";
    tbKeyCodes[tbKeyCodes["vkDivide"] = 111] = "vkDivide";
    tbKeyCodes[tbKeyCodes["vkF1"] = 112] = "vkF1";
    tbKeyCodes[tbKeyCodes["vkF2"] = 113] = "vkF2";
    tbKeyCodes[tbKeyCodes["vkF3"] = 114] = "vkF3";
    tbKeyCodes[tbKeyCodes["vkF4"] = 115] = "vkF4";
    tbKeyCodes[tbKeyCodes["vkF5"] = 116] = "vkF5";
    tbKeyCodes[tbKeyCodes["vkF6"] = 117] = "vkF6";
    tbKeyCodes[tbKeyCodes["vkF7"] = 118] = "vkF7";
    tbKeyCodes[tbKeyCodes["vkF8"] = 119] = "vkF8";
    tbKeyCodes[tbKeyCodes["vkF9"] = 120] = "vkF9";
    tbKeyCodes[tbKeyCodes["vkF10"] = 121] = "vkF10";
    tbKeyCodes[tbKeyCodes["vkF11"] = 122] = "vkF11";
    tbKeyCodes[tbKeyCodes["vkF12"] = 123] = "vkF12";
    tbKeyCodes[tbKeyCodes["vkF13"] = 124] = "vkF13";
    tbKeyCodes[tbKeyCodes["vkF14"] = 125] = "vkF14";
    tbKeyCodes[tbKeyCodes["vkF15"] = 126] = "vkF15";
    tbKeyCodes[tbKeyCodes["vkF16"] = 127] = "vkF16";
    tbKeyCodes[tbKeyCodes["vkF17"] = 128] = "vkF17";
    tbKeyCodes[tbKeyCodes["vkF18"] = 129] = "vkF18";
    tbKeyCodes[tbKeyCodes["vkF19"] = 130] = "vkF19";
    tbKeyCodes[tbKeyCodes["vkF20"] = 131] = "vkF20";
    tbKeyCodes[tbKeyCodes["vkF21"] = 132] = "vkF21";
    tbKeyCodes[tbKeyCodes["vkF22"] = 133] = "vkF22";
    tbKeyCodes[tbKeyCodes["vkF23"] = 134] = "vkF23";
    tbKeyCodes[tbKeyCodes["vkF24"] = 135] = "vkF24";
    tbKeyCodes[tbKeyCodes["vkNumlock"] = 144] = "vkNumlock";
    tbKeyCodes[tbKeyCodes["vkScrolllock"] = 145] = "vkScrolllock";
    tbKeyCodes[tbKeyCodes["vkComma"] = 188] = "vkComma";
    tbKeyCodes[tbKeyCodes["vkPeriod"] = 190] = "vkPeriod";
    tbKeyCodes[tbKeyCodes["vkSlash"] = 191] = "vkSlash";
    tbKeyCodes[tbKeyCodes["vkBackquote"] = 192] = "vkBackquote";
    tbKeyCodes[tbKeyCodes["vkOpenbracket"] = 219] = "vkOpenbracket";
    tbKeyCodes[tbKeyCodes["vkBackslash"] = 220] = "vkBackslash";
    tbKeyCodes[tbKeyCodes["vkClosebracket"] = 221] = "vkClosebracket";
    tbKeyCodes[tbKeyCodes["vkQuote"] = 222] = "vkQuote";
    tbKeyCodes[tbKeyCodes["vkMeta"] = 224] = "vkMeta";
})(tbKeyCodes || (tbKeyCodes = {}));
